import { Shield, HardHat, FileCheck, Clock4, Wrench } from "lucide-react";
import { SectionHeader } from "./Section";
import inspector from "@/assets/inspector-crane.jpg";

/* const VALUES = [
  {
    icon: Shield,
    title: "Integrity",
    desc: "Honest, transparent reporting on every inspection — without compromise.",
  },
  {
    icon: HardHat,
    title: "Safety",
    desc: "Zero-harm culture protecting people, assets and the environment.",
  },
  {
    icon: FileCheck,
    title: "Compliance",
    desc: "Aligned with API, ASME, LEEA, DNV and international codes.",
  },
  {
    icon: Clock4,
    title: "Reliability",
    desc: "On-time mobilization, dependable execution, repeatable results.",
  },
  {
    icon: Wrench,
    title: "Technical Excellence",
    desc: "Certified inspectors and engineers with decades of field experience.",
  },
]; */

const VALUES = [
  {
    icon: Shield,
    title: "Integrity",
    desc: "We deliver honest, transparent, and unbiased inspection findings, ensuring every report reflects the true condition of assets and equipment without compromise or influence.",
  },
  {
    icon: HardHat,
    title: "Safety",
    desc: "Safety is at the core of everything we do. Our inspections and engineering solutions are designed to protect people, safeguard assets, and promote a zero-harm working environment.",
  },
  {
    icon: FileCheck,
    title: "Compliance",
    desc: "We help clients achieve and maintain compliance with recognized international standards, including API, ASME, LEEA, DNV, and other industry-specific regulations and best practices.",
  },
  {
    icon: Clock4,
    title: "Reliability",
    desc: "Our clients rely on us for responsive support, timely project execution, and consistent delivery of accurate results that support critical operational decisions.",
  },
  {
    icon: Wrench,
    title: "Technical Excellence",
    desc: "Our team consists of highly skilled inspectors and engineers, including LEEA-certified professionals, bringing extensive industry knowledge and practical field experience to every project.",
  },
];
export function About() {
  return (
    <section id="about" className="section-y bg-background">
      {/* Top Section */}
      <div className="container-x grid gap-16 lg:grid-cols-12">
        {/* Image */}
        <div className="lg:col-span-5">
          <div className="relative">
            <img
              src={inspector}
              alt="Solid Proof Energy inspector at offshore crane site"
              width={1280}
              height={896}
              loading="lazy"
              className="aspect-[4/5] w-full rounded-2xl object-cover shadow-2xl"
            />

            <div className="absolute -bottom-8 -right-4 hidden rounded-xl bg-orange p-6 text-white shadow-xl sm:block lg:-right-8">
              {/* <div className="text-4xl font-black leading-none">20+</div>
              <div className="mt-1 text-xs font-semibold uppercase tracking-widest">
                Years Of
                <br />
                Field Expertise
              </div> */}
              <div className="text-4xl font-black leading-none">20+</div>
<div className="mt-1 text-xs font-semibold uppercase tracking-widest">
  Combined Team
  <br />
  Experience
</div>
            </div>
          </div>
        </div>

        {/* Content */}
        <div className="lg:col-span-7">
          <SectionHeader
            eyebrow="About Solid Proof Energy"
            title="Engineering trust for the world's most demanding industries."
            intro="Solid Proof Energy is an independent inspection, certification and engineering services partner for the offshore energy, oil & gas, marine and heavy industrial sectors. We help operators de-risk assets, extend service life and meet the highest international standards."
          />

          <div className="mt-10 grid gap-6 sm:grid-cols-2">
            <div className="rounded-xl border border-border bg-light-gray p-6">
              <div className="text-xs font-bold uppercase tracking-widest text-orange">
                Mission
              </div>
              <p className="mt-3 text-base text-navy-deep">
              To deliver trusted  third party inspection, certification, and engineering solutions that
  protect people, assets, and operations while ensuring the highest standards
  of safety, quality, and compliance.
              </p>
            </div>

            <div className="rounded-xl border border-border bg-light-gray p-6">
              <div className="text-xs font-bold uppercase tracking-widest text-orange">
                Vision
              </div>
              <p className="mt-3 text-base text-navy-deep">
               To become the most trusted provider of independent inspection and engineering solutions,
                supporting safe, reliable, and sustainable operations across the energy and industrial industries.
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* Why Choose */}
      <div className="container-x mt-20">
        <h3 className="text-center text-2xl font-bold text-navy-deep">
          Why Choose Solid Proof Energy
        </h3>

        <div className="mt-8 grid gap-6 sm:grid-cols-2 lg:grid-cols-5">
          {VALUES.map((v) => (
            <div
              key={v.title}
              className="group rounded-xl border border-border bg-card p-5 transition-all hover:border-orange hover:shadow-lg"
            >
              <span className="grid h-11 w-11 place-items-center rounded-md bg-navy-deep text-orange transition-colors group-hover:bg-orange group-hover:text-white">
                <v.icon className="h-5 w-5" />
              </span>

              <div className="mt-4 text-base font-bold text-navy-deep">
                {v.title}
              </div>

              <p className="mt-1.5 text-sm leading-relaxed text-muted-foreground">
                {v.desc}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}